export enum HttpStatus {
  CODE200 = 200, // OK
  CODE201 = 201, // Created
  CODE202 = 202, // Accepted
  CODE203 = 203, // Non-Authoritative Information
  CODE204 = 204, // No Content
  CODE205 = 205, // Reset Content
  CODE206 = 206, // Partial Content
  CODE300 = 300, // Multiple Choices
  CODE301 = 301, // Moved Permanently
  CODE302 = 302, // Found
  CODE303 = 303, // See Other
  CODE304 = 304, // Not Modified
  CODE305 = 305, // Use Proxy
  CODE307 = 307, // Temporary Redirect
  CODE400 = 400, // Bad Request
  CODE401 = 401, // Unauthorized
  CODE402 = 402, // Payment Required
  CODE403 = 403, // Forbidden
  CODE404 = 404, // Not Found
  CODE405 = 405, // Method Not Allowed
  CODE406 = 406, // Not Acceptable
  CODE407 = 407, // Proxy Authentication Required
  CODE408 = 408, // Request Timeout
  CODE409 = 409, // Conflict
  CODE410 = 410, // Gone
  CODE411 = 411, // Length Required
  CODE412 = 412, // Precondition Failed
  CODE413 = 413, // Request Entity Too Large
  CODE414 = 414, // Request-URI Too Long
  CODE415 = 415, // Unsupported Media Type
  CODE416 = 416, // Requested Range Not Satisfiable
  CODE417 = 417, // Expectation Failed
  CODE500 = 500, // Internal Server Error
  CODE501 = 501, // Not Implemented
  CODE502 = 502, // Bad Gateway
  CODE503 = 503, // Service Unavailable
  CODE504 = 504, // Gateway Timeout
  CODE505 = 505  // HTTP Version Not Supported'
}
